import React, { useState, useEffect } from "react";
import { translate } from "react-i18next";
import { TeamService } from "services";
import { npsColors } from "commons/utils/moodModal";

import {
  Container,
  NumberDiv,
  NumberSpan,
  NumbersWrapper,
  Title,
  JustificationInput,
  MandatoryNpsLabel
} from './styles.js'

const NPS = ({
  npsSelected,
  setNpsSelected,
  setNpsId,
  setNpsJustification,
  showJustificationNpsInput,
  setShowNpsBox,
  requiredMoodAction,
  mandatoryLabel,
  t
}) => {
  const [npsQuestion, setNpsQuestion] = useState('');
  const [numSize, setNumSize] = useState(12);

  const calcNumSize = () => {
    const size = window.innerWidth * .03
    return size > 22 ? 22 : size;
  }

  useEffect(() => {
    const getNpsInfo = async () => {
      const nps = await TeamService.getNpsInfo();
      const { question, id } = nps.attributes;
      setNpsQuestion(question);
      setNpsId(id);
      setShowNpsBox(question.trim() !== '');
    }
    getNpsInfo();
    const size = calcNumSize();
    setNumSize(size);
  }, []);

  return (
    <Container data-testid="nps" show={npsQuestion && npsQuestion.trim() !== ''}>
      <Title data-testid="nps-title">
        {npsQuestion}
        {requiredMoodAction && (<MandatoryNpsLabel className="mandatory-nps-label">({t('mood.required')})</MandatoryNpsLabel>)}
      </Title>
      <NumbersWrapper data-testid="nps-numbers-wrapper">
        {
          npsColors.map(({ color }, num) => {
            return <Number
              key={`nps-number-${num}`}
              color={color}
              num={num}
              selected={npsSelected}
              setSelected={setNpsSelected}
              size={numSize}
            />
          })
        }
      </NumbersWrapper>
      {showJustificationNpsInput &&
        <>
          <Title data-testid="justification-title">
            {t('mood.justificationTitle')}
            {mandatoryLabel && (<MandatoryNpsLabel className="mandatory-nps-label">({t('mood.required')})</MandatoryNpsLabel>)}
          </Title>
          <JustificationInput
            onChange={(event) => setNpsJustification(event.target.value)}
            placeholder={t('mood.justificationPlaceholder')}
            spellCheck={true}
            data-testid="justification-input"
          />
        </>
      }
    </Container>
  );
}

const Number = ({ num, color, selected, setSelected, size }) => {
  return (
    <NumberDiv
      onClick={() => setSelected(num)}
    >
      <NumberSpan
        color={color}
        selected={selected === num}
        size={size}
      >
        {num}
      </NumberSpan>
    </NumberDiv>
  );
}

export default translate()(NPS);
